import React, { useState, useContext } from 'react';
import { AsyncTypeahead, useItem, Menu } from 'react-bootstrap-typeahead';
import DropDown from 'react-bootstrap/Dropdown';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import LocaleContext from 'constants/localization';
import { isArchivedObjectFormat, convertFormatToLocalizedView } from 'helpers/dataHelpers';

// to parse the results
const mapToValues = options => options.map(option => { 
  return {display: option.value, uri: option.id};
});

const RESULT_LIMIT_WARNING = 50;

export default function AutoSuggest(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState(['']);
  const [prefix, setPrefix] = useState('');
  const [query, setQuery] = useState('');
  const LS = useContext(LocaleContext);

  const { onSelect, getSuggestions, disabled, objectFormat } = props;
  let { minLength, placeholder, style } = props;

  minLength = minLength || 3;
  const type = getRecordType(LS, objectFormat);
  placeholder = placeholder || LS.actions.search + type;
  style = style || {};

  const handleSearch = (query) => {

    setQuery(query);

    if(query.length >= 3){
      let newPrefix = query.slice(0,3);

      if(newPrefix != prefix){
        setPrefix(newPrefix);

        setIsLoading(true);
        getSuggestions(newPrefix).then(options => {
          setOptions(mapToValues(options));
          setIsLoading(false);
        });
      }
    }
  };

  const handleChange = input => {
    if (input.length > 0) {
      onSelect(input[0]);
      setInputValue(['']);
    } else {
      setInputValue(input);
    }
  };

  const MenuItem = (props) => <DropDown.Item {...useItem(props)} />;

  // Bypass client-side filtering by returning `true`.
  //const filterBy = () => true;

  return (
    <div style={style}>
      {
        (options?.length >= RESULT_LIMIT_WARNING && query.length <= minLength) && 
        <p className="text-danger">{LS.warning.resultLimit}</p>
      }
      <AsyncTypeahead
        disabled={disabled}
        selected={inputValue}
        onChange={handleChange}
        onSearch={handleSearch}
        minLength={minLength}
        isLoading={isLoading}
        options={options}
        id="async-suggest"
        labelKey="display"
        placeholder={placeholder}
        renderMenu={(results, menuProps) => (
          <Menu {...menuProps}>
            {results.map((option, i) => (
              <MenuItem option={option} position={i} key={i}>
                {option.display}
              </MenuItem>
            ))}
          </Menu>
        )}
      />
    </div>
  );
}

/**
 * 
 * @param {*} LocaleContext 
 * @param {*} objectFormat 
 * @returns converts objectFormat to localized object type
*/
const getRecordType = (LocaleContext, objectFormat) => { 
  let type = '';
  if (isArchivedObjectFormat(objectFormat)) {
    type = ' ' + convertFormatToLocalizedView(LocaleContext, objectFormat)?.toLowerCase();
  }
  return type;
};